import {
  Box,
  ButtonProps,
  DialogTitle,
  SxProps,
  Typography,
} from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_DRAG_HANDLE_SELECTOR,
  NO_DRAG_SELECTOR,
} from "../../../../app/constants";
import { Nullable } from "../../../types/nullable";
import DialogComponent from "../dialogs/DialogComponent";
import OverlaySpinner from "../overlaySpinner/OverlaySpinner";
import { CustomButton } from "../customButton/CustomButton";

type Props = {
  title: string;
  contentText: string | ReactElement;
  cancelText?: Nullable<string>;
  confirmText: string;
  onConfirm: () => void;
  onCancel?: () => void;
  isOpen: boolean;
  sx?: SxProps;
  titleSx?: SxProps;
  CancelButtonProps?: ButtonProps;
  ConfirmButtonProps?: ButtonProps;
  isLoading?: boolean;
};

/**
 * @deprecated: use useConfirmationDialog hook instead
 */
export const ConfirmationDialog = ({
  title,
  contentText,
  cancelText,
  confirmText,
  onConfirm,
  onCancel,
  isOpen,
  sx,
  titleSx,
  CancelButtonProps = {},
  ConfirmButtonProps = {},
  isLoading = false,
}: Props) => {
  const { t } = useTranslation("common");

  return (
    <DialogComponent
      open={isOpen}
      onClose={() => {}}
      autoWidth
      DialogContentProps={{ sx: { padding: "0px" } }}
      sx={{
        borderRadius: "4px",
        minWidth: "450px",
        maxWidth: "650px",
        ...sx,
      }}
    >
      <Box width="100%">
        <DialogTitle
          sx={{ cursor: "grab", ...titleSx }}
          className={DEFAULT_DRAG_HANDLE_SELECTOR}
        >
          <Typography variant="header" fontWeight={600} fontSize={23}>
            {title}
          </Typography>
        </DialogTitle>
        <OverlaySpinner isLoading={isLoading} />
        <Box className={NO_DRAG_SELECTOR} padding="8px 24px">
          {typeof contentText === "string" ? (
            <Typography>{contentText}</Typography>
          ) : (
            contentText
          )}
        </Box>
        <Box
          padding="8px 16px"
          display="flex"
          justifyContent="space-between"
          sx={{ cursor: "grab" }}
        >
          {onCancel && (
            <CustomButton
              sx={{ borderRadius: "20px" }}
              onClick={onCancel}
              {...CancelButtonProps}
            >
              {cancelText || t("cancel")}
            </CustomButton>
          )}
          <CustomButton
            sx={{ borderRadius: "20px" }}
            onClick={onConfirm}
            {...ConfirmButtonProps}
          >
            {confirmText}
          </CustomButton>
        </Box>
      </Box>
    </DialogComponent>
  );
};
